// assets.js

/**
 * Export the links for the Logos and Icons that are storage in the Blob Storage
 */

const BLOB_URL =
  "https://quickmovestorage.blob.core.windows.net/quickmove-static-files/";

export const LOGOS = {
  QUICKMOVE_DASH: `${BLOB_URL}logo-quickmove-side-bar.png`,
  QUICKMOVE_FLOW: `${BLOB_URL}quickmove_logo.svg`,
  PAYPAL: `${BLOB_URL}paypal.svg`,
  VISA: `${BLOB_URL}visa.svg`,
  MASTER: `${BLOB_URL}master.svg`,
};

export const IMAGES = {
  WELCOME_IMAGE: `${BLOB_URL}welcome_image.svg`,
  EXCLAMATION_IMAGE: `${BLOB_URL}exclamation.svg`,
  CONGRATULATIONS_IMAGE: `${BLOB_URL}congratulations.svg`,
  PROGRESS_BAR_6: `${BLOB_URL}progress.bar.6.svg`,
  UPDATE_PROFILE_IMAGE: `${BLOB_URL}update-profile.svg`,
};

export const ICONS = {
  ADDRESS_ICON: `${BLOB_URL}address-icon.svg`,
  EMAIL_ICON: `${BLOB_URL}email-icon.svg`,
  HOME_ICON: `${BLOB_URL}home-icon.svg`,
  GENDER_ICON: `${BLOB_URL}gender-icon.svg`,
  LOAD_ICON: `${BLOB_URL}load-icon.svg`,
  LOG_OUT_ICON: `${BLOB_URL}log-out-icon.svg`,
  ORDER_ICON: `${BLOB_URL}orders-icon.svg`,
  PHONE_ICON: `${BLOB_URL}phone-icon.svg`,
  PROFILE_ICON: `${BLOB_URL}profile-icon.svg`,
  PROFILE_ICON_PURPLE: `${BLOB_URL}profile-icon-purple.svg`,
  USER_ICON: `${BLOB_URL}user-icon.svg`,
  CARET_ICON: `${BLOB_URL}caret-icon.svg`,
  UPLOAD_FILE_ICON: `${BLOB_URL}upload-file-icon.svg`,
  SIGNOUT_ICON: `${BLOB_URL}signout-icon.svg`,
  BELL_ICON: `${BLOB_URL}bell-icon.svg`,
  MENU_ICON: `${BLOB_URL}menu-icon.svg`,
  CHECK_ICON: `${BLOB_URL}check-icon.svg`,
  CLOSE_ICON: `${BLOB_URL}close-icon.svg`,
  SETA_ICON: `${BLOB_URL}seta-icon.svg`,
  ID_BADGE_ICON: `${BLOB_URL}id-badge-icon.svg`,
  ID_CARD_ICON: `${BLOB_URL}id-card-icon.svg`,
};
